module.exports = __webpack_public_path__ + "media/images/sp/stores/sola/bnr_resort_fair_banner_sp-e4f03e2bdd7144ced0f7ea74138cbdc8.jpg";